<template>
    <v-layout align-start justify-start row wrap> 
        <v-flex xs12 class="py-0 mb-0">           
            <span class="red--text py-0 my-0" v-if="errors.collect(attributes.variable,vuexnamespace)">{{ errors.first(attributes.variable, vuexnamespace) }}</span>            
        </v-flex>
        <v-flex xs12>
        <small>{{attributes.hint}} </small></br>
        </v-flex>
        <v-flex xs12 sm6 md4>
            <v-menu
                :close-on-content-click="false"
                v-model="menu2"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
            >
                <v-text-field
                    slot="activator"
                    v-model="result"                    
                    prepend-icon="event"
                    readonly
                ></v-text-field>
                <v-date-picker v-model="result" v-on:input="menu2 = false"></v-date-picker>
            </v-menu>
        </v-flex>    
    </v-layout>    
</template>

<script>
export default {   
    inject: ['$validator'],
    
    props:[
        'attributes',
        'vuexnamespace'
    ],
    data() {
        return {
            date: new Date().toISOString().substr(0, 10),
            menu2:false
        }
    },
    computed: {
        result: {
            get(){
                return this.$store.getters[this.vuexnamespace + '/data'](this.attributes.variable)
            },            
            set(value) {
                if (this.$validator.validateAll())
                    this.$store.commit(this.attributes.setter, value)
            }
        }
        
    },
}
</script>
